import Button from './Button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';

const ListButton = ({ to, ...props }) => {
    const { t } = useTranslation();

    return (
        <>
            <Link to={to} style={{ textDecoration: 'none' }}>
                <Button type="button" variant="outlined" {...props}>
                    {t('act_goto_list')}
                </Button>
            </Link>
        </>
    );
};
export default ListButton;
